import { useCallback, useMemo, useState } from 'react';
import useFeatures from './useFeatures';
import useSearchParamsConfig from './useSearchParamsConfig';

export default function useProjectRoleFilters(defaultSearchParams) {
  const features = useFeatures();

  const filters = useMemo(
    () => ({
      projectRoles: [],
      projectRoleDisciplines: [],
    }),
    [],
  );

  const [defaultParams] = useState(defaultSearchParams);

  const searchParamsConfig = useSearchParamsConfig();

  const roleSearchParamsConfig = useMemo(
    () => ({
      projectRoles: searchParamsConfig.projectRoles,
      projectRoleDisciplines: searchParamsConfig.projectRoleDisciplines,
      ...defaultParams,
    }),
    [searchParamsConfig, defaultParams],
  );

  const mapUrlSearchParams = useCallback(
    (params) => ({
      projectRoleId: params.projectRoles?.map((v) => v.id),
      projectRoleDisciplineId: params.projectRoleDisciplines?.map((v) => v.id),
    }),
    [],
  );

  const mapClickThroughParams = useCallback(
    (filters) => ({
      projectRoleId: filters.projectRoles?.map((v) => v.id),
      projectRoleDisciplineId: features.disciplines ? filters.projectRoleDisciplines?.map((v) => v.id) : undefined,
    }),
    [features.disciplines],
  );

  return useMemo(
    () => ({ filters, searchParamsConfig: roleSearchParamsConfig, mapUrlSearchParams, mapClickThroughParams }),
    [filters, roleSearchParamsConfig, mapUrlSearchParams, mapClickThroughParams],
  );
}
